module.exports = __webpack_public_path__ + "img/South Carolina outline.a4e7c660.png";